import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

import {Items} from '../../models/items';
import {HeaderData} from '../../models/header-data';
import {HeaderDataService} from '../../services/header-data.service';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css'],
    providers: [HeaderDataService],
    animations: [
        trigger('slideInOut', [
            state('in', style({height: '*'})),
            transition('void => *', [
                style({height: 0}),
                animate(250, style({height: '*'}))
            ]),
            transition('* => void', [
                style({height: '*'}),
                animate(250, style({height: 0}))
            ])
        ])
    ]
})
export class NavComponent implements OnInit {
    @Output() selected: EventEmitter<any> = new EventEmitter();

    @Input() currentAppLabel: string;
    @Input() closeOnState: boolean = false;
    @Input() menuHeaderData: HeaderData;

    menuData: any;
    userMenuLabel: string;
    showUserMenu = false;
    showAppMenu = false;
    expandedNavUser = 'fa fa-chevron-down';
    expandedNavApp = 'fa fa-chevron-down';
    appMenuArray: Items[];
    userMenuArray: Items[];
    headerBtnMenu: Items;
    headerDataItems: HeaderData[];
    errorMessage: string;
    currentUser: string;
    headerBtnContent = false;

    public toggleUserMenu(event) {
        if (this.currentUser === undefined) {
            return;
        }
        this.showAppMenu = false;
        this.showUserMenu = !this.showUserMenu;
        if (this.showUserMenu) {
            this.expandedNavUser = 'fa fa-chevron-up';
        } else {
            this.expandedNavUser = 'fa fa-chevron-down';
        }
        this.expandedNavApp = 'fa fa-chevron-down';
    }

    toggleAppMenu(event) {
        if (this.currentUser === undefined) {
            return;
        }
        this.showUserMenu = false;
        if (this.currentUser === undefined) {
            return;
        }
        this.showAppMenu = !this.showAppMenu;
        if (this.showAppMenu) {
            this.expandedNavApp = 'fa fa-chevron-up';
        } else {
            this.expandedNavApp = 'fa fa-chevron-down';
        }
        this.expandedNavUser = 'fa fa-chevron-down';
    }

    userMenuToggleClass() {
    }

    closeNavBar() {
        this.expandedNavApp = 'fa fa-chevron-down';
        this.expandedNavUser = 'fa fa-chevron-down';
        this.showAppMenu = false;
        this.showUserMenu = false;
    }

    getHeadMenuData() {
        this.parseHeaderDataResponse(this.menuHeaderData);
        // this.headerDataService.getMenuItems(this.menuEndpoint).subscribe(
        //     (data: HeaderData) => {
        //         this.parseHeaderDataResponse(data);
        //     },
        //     error => this.headerDataService.errorProc(error));
    }

    parseHeaderDataResponse(data: any) {
        if (this.menuData === undefined) {
            this.menuData = data;
        }

        if (this.userMenuLabel === undefined) {
            this.currentUser = this.menuData.userMenuLabel;
        } else {
            this.currentUser = this.userMenuLabel;
        }

        this.appMenuArray = this.menuData.appMenu;
        this.userMenuArray = this.menuData.userMenu;

        if (this.menuData.headerBtnMenu.length > 0) {
            this.headerBtnMenu = this.menuData.headerBtnMenu[0];
        }

        // if (data.headerBtnMenu !== undefined) {
        //   this.headerBtnContent = true;
        // }
    }

    onClicked(item: Items) {
        this.selected.emit(item);
        this.currentAppLabel = item.label;
        this.closeNavBar();
    }

    constructor(private headerDataService: HeaderDataService) {
    }

    ngOnInit() {
        this.getHeadMenuData();
        if (this.currentAppLabel === undefined) {
            this.currentAppLabel = 'Current App';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/nav/nav.component.ts